import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import {useLocalization} from 'localization';
import {ActivityIndicator, Layout, Spacer, Text} from 'components';

export const SearchingAgent: React.FC = () => {
  const {t} = useLocalization();
  const {colors} = useTheme();

  const containerSx: SxProps = useMemo(
    () => ({
      // height: 10,
      padding: 2,
      borderRadius: 2,
      backgroundColor: colors.lightBeige,
    }),
    [colors],
  );
  return (
    <Layout sx={containerSx}>
      <Layout horizontal adjustCenter adjustLeft>
        <ActivityIndicator size={'small'} />
        <Spacer size={1} />
        <Text kind="primary" variant="h3">
          {t('wizard.agent.step.1.searching')}
        </Text>
      </Layout>
    </Layout>
  );
};
